import PropTypes from "prop-types";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Container, Link, Typography } from "@mui/material";

import { Root, Title } from "./styles";

const RichTextFooter = ({ richText }) => {
  const options = {
    renderNode: {
      [BLOCKS.DOCUMENT]: (_node, children) => <Root>{children}</Root>,
      [BLOCKS.HEADING_2]: (_node, children) => <Title variant="h2">{children}</Title>,
      [BLOCKS.HEADING_3]: (_node, children) => <Typography variant="h3">{children}</Typography>,
      [INLINES.HYPERLINK]: (_node, children) => (
        <Link href={_node.data.uri} target="_blank" rel="noreferrer">
          {children}
        </Link>
      ),
    },
  };

  const footer = documentToReactComponents(richText, options);

  return richText ? <Container>{footer}</Container> : null;
};

RichTextFooter.propTypes = {
  richText: PropTypes.shape(),
};

export default RichTextFooter;
